export default __webpack_public_path__ + "static/media/designerduweb.25085b73.webp";